import {
  useReturnConditions,
  useSaveReturnConditions
} from '@/application/manage-return-conditions'
import { useAppSelector } from '@/redux/hooks'
import { Roles } from '@/utils'
import { ReturnConditionsForm } from '@/ui/components/settings-components'
import { ReverLoading } from '@itsrever/design-system'
import { useTranslation } from 'react-i18next'
import { LoadError, NavigationTabs, PageHeader } from '@/ui/shared'
import { useReturnConditionsTabs } from './configuration-tabs'
import {
  isDashboardBlocked,
  useFeatureFlag
} from '@/application/use-feature-flag'
import { BlockedDashboardOverlay } from '@/ui/components/overlays/blocked-dashboard-overlay'

export default function ReturnConditions() {
  const { t } = useTranslation()
  const { isFlagEnabled } = useFeatureFlag(isDashboardBlocked, {
    pageName: 'configuration'
  })
  const {
    returnConditions,
    setReturnConditions,
    originalReturnConditions,
    loadingReturnConditions,
    returnConditionsFailed,
    reloadReturnConditions
  } = useReturnConditions()
  const { callSaveReturnConditions, loadingSaveReturnConditions } =
    useSaveReturnConditions()

  const role = useAppSelector((s) => s.userApi.getMe.response.user?.role)
  const canEdit = role === Roles.ReadWrite

  const tabs = useReturnConditionsTabs()

  if (loadingReturnConditions) return <ReverLoading />
  return (
    <>
      <NavigationTabs tabs={tabs} selectedIndex={0} />
      {isFlagEnabled && <BlockedDashboardOverlay />}
      <PageHeader
        title={t('return_conditions.title')}
        description={t('return_conditions.description')}
      />
      <div className="flex flex-col gap-4 px-7 py-4">
        <div className="max-w-[750px]">
          {returnConditionsFailed ? (
            <LoadError
              message={t('return_conditions.load_error')}
              onRetry={reloadReturnConditions}
            />
          ) : (
            <ReturnConditionsForm
              canEdit={canEdit}
              returnConditions={returnConditions}
              originalReturnConditions={originalReturnConditions}
              setReturnConditions={setReturnConditions}
              saveReturnConditions={callSaveReturnConditions}
              loadingSaveReturnConditions={loadingSaveReturnConditions}
            />
          )}
        </div>
      </div>
    </>
  )
}
